"use client";

import React, { useEffect, useState } from "react";

import ModalWrapper from "@/app/shared-components/modal/modal-wrapper";

import PartialMedicalDeclineModalContent from "./partial-medical-decline-modal-content";

interface PartialMedicalDeclineModalProps {
  showModal?: boolean;
  partialMedicalDeclineModalContent?: {
    title?: string;
    description?: string;
    ctaLabel?: string;
  } | null;
  onClose?: () => void;
}

function PartialMedicalDeclineModal({
  showModal = false,
  partialMedicalDeclineModalContent,
  onClose,
}: Readonly<PartialMedicalDeclineModalProps>) {
  const [isOpen, setIsOpen] = useState(showModal);

  const { title, description, ctaLabel } =
    partialMedicalDeclineModalContent ?? {};

  // Sync modal state with prop changes
  useEffect(() => {
    setIsOpen(showModal);
  }, [showModal]);

  const handleContinue = () => {
    setIsOpen(false);
    // Notify parent that modal was closed
    if (onClose) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <ModalWrapper
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      isDismissable={false}
      className="md:p-spacing-xxxl p-spacing-l md:max-w-[442px] lg:max-w-[586px] max-w-[327px] w-full"
    >
      <PartialMedicalDeclineModalContent
        title={title}
        description={description}
        ctaButtonLabel={ctaLabel}
        onContinue={handleContinue}
      />
    </ModalWrapper>
  );
}

export default PartialMedicalDeclineModal;
